import { Icon, IconProps } from '@chakra-ui/react';

export const ScreeningIcon = ({ ...rest }: IconProps) => {
  return (
    <Icon viewBox="0 0 10 14" fill="none" width="14px" height="14px" {...rest}>
      <path
        d="M5.02645 0.875C5.67078 0.875 6.19312 1.39733 6.19312 2.04167H8.78906C9.43339 2.04167 9.95573 2.564 9.95573 3.20833V12.5417C9.95573 12.8638 9.69456 13.125 9.3724 13.125H8.0599C7.73773 13.125 7.47656 12.8638 7.47656 12.5417V5.22955L2.51823 5.22955V12.5417C2.51823 12.8638 2.25706 13.125 1.9349 13.125H0.622396C0.30023 13.125 0.0390625 12.8638 0.0390625 12.5417V3.20833C0.0390625 2.564 0.561397 2.04167 1.20573 2.04167H3.85978C3.85978 1.39733 4.38212 0.875 5.02645 0.875Z"
        fill="currentColor"
      />
    </Icon>
  );
};
